export interface IMessageProps {
  message: React.ReactNode;
  withBorder?: boolean;
  type: MessageTypeEnum;
}

export enum MessageTypeEnum {
  Warning = 'Warning',
  Info = 'Info',
  Success = 'Success',
}
